import { GoogleDocsAppRow } from '../components/GoogleDocsAppRow';
import type { AppRow } from '../type/AppRow';

export const googleDocsAppRow: AppRow = {
  key: 'google_docs',
  name: 'Google Docs',
  AppComponent: GoogleDocsAppRow,
};
